import RequestAbstract from "../abstract";

export default class AccountingGatewayTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-gateway-transactions";
    }

}
